import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, LinkUnderline, ErrorForm, InputForm } from '../../components'
import { AuthContext, AuthContextType } from '../../contexts/authContext'
import { useForm, Controller } from 'react-hook-form'
import { useYupValidation } from '../../hooks'
import { loginSchema } from '../../yup'
import { IAuthContext, IAuthLogin } from '../../interfaces'
import { errorHandler } from '../../services'
import { AuthService } from '../../services/index'
import logo from '../../assets/images/logo.png'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'
import { ERROR_TYPE } from '../../enums/errorType'

export default function Login(): React.ReactElement {
    const [isLoading, setIsLoading] = React.useState(false)

    const navigate = useNavigate()
    const { logIn } = useContext(AuthContext) as AuthContextType
    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IAuthLogin>({
        resolver: useYupValidation(loginSchema),
    })

    async function login(values: IAuthLogin): Promise<void> {
        setIsLoading(true)
        try {
            const response = await AuthService.login(values)
            if (response.accessToken) {
                const loggedUser: IAuthContext = {
                    user: {
                        name: response.user.name,
                        email: response.user.email,
                        imageUrl: response.user.imageUrl,
                    },
                    accessToken: response.accessToken,
                    refreshToken: response.refreshToken,
                }

                logIn(loggedUser)
                navigate('/')
            }
        } catch (err) {
            if (err instanceof AxiosError) {
                const type = err.response?.data.errorType
                toast(errorHandler(err).message, {
                    type: type === ERROR_TYPE.USER_AWAITING ? 'warning' : 'error',
                })
            }
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="box-login">
            <div className="login__backgound">
                <div className="login__content">
                    <div className="login__images">
                        <img src={logo} alt="Logo CNA construtora" className="login__logo" />
                        <div className="fino-acabamento-box">
                            <p className="fino-acabamento-logo">Fino</p>
                            <p className="fino-acabamento-logo">Acabamento</p>
                        </div>
                    </div>
                    <h4>Área restrita exclusiva para clientes CNA.</h4>
                    <form className="login__inputs" onSubmit={handleSubmit(login)}>
                        <Controller
                            name="email"
                            defaultValue={''}
                            control={control}
                            render={({ field: { value, onChange } }) => {
                                return <InputForm label="E-mail" placeholder="E-mail" name="email" value={value} onChange={onChange} />
                            }}
                        />
                        <ErrorForm error={errors.email?.message} />
                        <Controller
                            name="password"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputForm label="Senha" type="password" placeholder="Senha" name="password" value={value} onChange={onChange} />
                                )
                            }}
                        />
                        <ErrorForm error={errors.password?.message} />

                        <div className="forgotPass-box">
                            <LinkUnderline placeholder="Solicitar cadastro" onClick={() => navigate('/request-access')} />
                            <LinkUnderline placeholder="Esqueci minha senha" onClick={() => navigate('/forgot-pass')} />
                        </div>
                        <div className="box-button-login">
                            <Button isLoading={isLoading} type={'submit'} placeholder="Entrar" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
